/**
 * Wires the active-branch id onto every outgoing API request as the
 * `X-Branch-Id` header. The backend reads tenantId from the JWT itself
 * (per spec — see BACKEND_AGENT_PROMPTS.md §3) but branch is a
 * within-tenant scope and has to be passed explicitly.
 *
 * Call once at app start, after configureApi(...).
 */
import { apiClient } from '@kss/api';
import { getActiveBranchId } from './branchStore';

let installed = false;

export function setupBranchHeader(): void {
  if (installed) return;
  installed = true;

  apiClient.interceptors.request.use((config) => {
    const id = getActiveBranchId();
    if (id) {
      config.headers = config.headers ?? {};
      // Both header casings tolerated server-side; we send the canonical one.
      (config.headers as Record<string, string>)['X-Branch-Id'] = id;
    }
    return config;
  });
}
